import React from 'react';
import * as modalTypes from '../Modals/modalTypes';
import { useDispatch } from 'react-redux';
import * as actions from '../../store/actions/index';
import Aux from '../../hoc/Aux';

const wizardStandardSubHeader = (props) => {

  const dispatch = useDispatch();

  const showWizardInfoModal = () => {
    const modalProps = {open: true, formObject: { text: props.modalTextToken, title: props.modalTitle }};
    const modalType = modalTypes.MODAL_SHOW_WIZARD_INFO;
    dispatch(actions.showModal({ modalProps, modalType }));
  }

  return (
    <Aux>
      { (props.display === true)?
        <Aux>
      <h2 style={{display: "inline"}}>{props.title}</h2>
      <button style={{display: "inline", marginBottom: "0px", paddingTop: "3px"}} className="btn btn-round" onClick={showWizardInfoModal}>
        <i className="material-icons">help</i>
      </button>
      </Aux> : <h2 style={{display: "inline"}}> </h2>
    }
    </Aux>
  )

};

export default wizardStandardSubHeader;



// WEBPACK FOOTER //
// ./src/components/Wizard/WizardStandardSubHeader.js